import { lazy, Suspense, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import type { ComponentProps } from "react";
import type { BookMap as BookMapType } from "@/components/BookMap";

const BookMapImpl = lazy(async () => {
  const mod = await import("@/components/BookMap");
  return { default: mod.BookMap };
});

type Props = ComponentProps<typeof BookMapType>;

function MapFallback() {
  return (
    <div className="flex h-[520px] w-full items-center justify-center rounded-2xl bg-muted">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
    </div>
  );
}

/** Browser-only wrapper: Leaflet touches `window` at import time, so it must never load during SSR. */
export function LazyBookMap(props: Props) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return <MapFallback />;
  return (
    <Suspense fallback={<MapFallback />}>
      <BookMapImpl {...props} />
    </Suspense>
  );
}
